const BASE_URL = 'http://localhost:3001';
// const BASE_URL = 'https://comics-list-api.onrender.com';
export default BASE_URL;
